import { graphql } from "msw";
import { mockCart, mockCartOrderSummary } from "./mockCart";
import { mockOnePassSelectedOption } from "./mockOnePassSubscription";
import { OrderSummaryQuery } from "@cart-app/generated/graphql";

export const handler = graphql.query<OrderSummaryQuery>(
  "OrderSummary",
  (_request, response, context) => {
    let cartTotal = (mockCartOrderSummary.giftCards || [])?.reduce(
      (acc, giftCard) => (acc -= giftCard.appliedBalance.amount),
      mockCartOrderSummary.subtotalPrice.amount
    );

    cartTotal = (mockCartOrderSummary.discounts || [])?.reduce(
      (acc, coupon) => (acc -= coupon.discount.amount),
      cartTotal
    );

    return response(
      context.data({
        __typename: "Query" as const,
        cart: {
          ...mockCart,
          orderSummary: {
            ...mockCartOrderSummary,
            totalPrice: {
              __typename: "Money" as const,
              amount: cartTotal,
              currency: "AUD",
            },
          },
          clubSubscription: {
            selectedOption: {
              ...mockOnePassSelectedOption,
            },
          },
        },
      })
    );
  }
);
